export enum ResultTypes {
  INFORMATION = 'information',
  STATUS = 'status',
}
export enum FinalStates {
  ERROR = 'error',
  PENDING = 'pending',
  SUCCESS = 'success',
  PAYMENT_METHOD_ERROR = 'paymentMethodError',
  RESTRICTED = 'restricted',
}

export enum ResultMessageTypes {
  STRING = 'string',
  HTML = 'html',
}

export interface ResultMessage {
  content: string;
  type: ResultMessageTypes;
}
